let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1lvsb")).then(() => parcelRequire('jVNaF'));